import React, { useEffect } from "react";
import "./loading.css";
import loadingGif from "../../assets/img/loading_1.2.gif";

// 전역 로딩 오버레이. body 스크롤을 잠그고 페이드 아웃 애니메이션을 지원한다.
const Loading = ({ isLoading }) => {
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);
  return (
    <div className={`loading-overlay ${!isLoading ? "fade-out" : ""}`}>
      <div className="loading-container">
        <img src={loadingGif} alt="Loading" className="loading-gif" />
        <p className="loading-text">
          Loading
          <span className="loading-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </div>
  );
};

export default Loading;
